import React from "react";
import styled from "styled-components";

const StyledDetails = styled.details`
  margin: 1em 0;
  font-weight: 500;
  font-size: var(--fz-md);

  summary {
    cursor: pointer;
  }

  .content {
    color: ${({ theme }) => theme?.colors?.descfont};
    font-weight: 400;
    padding-left: 15px;
    font-size: var(--fz-sm);
  }

  @media (min-width: 800px) {
    font-size: var(--fz-md);

    .content {
      font-size: var(--fz-md);
    }
  }
`;

const Accordion = ({ title, children, open }: any) => {
  return (
    <div>
      <StyledDetails open={open}>
        <summary>{title}</summary>
        <p className="content" style={{ whiteSpace: "pre-line" }}>
          {children}
        </p>
      </StyledDetails>
    </div>
  );
};

export default Accordion;
